import React, { forwardRef } from "react";

import { FeatureFlagEnum } from "@/features/feature-flag/constants";
import { FeatureGate } from "@/features/feature-flag/components/FeatureGate";
import { NPSUpdatedCalendar } from "@/components/NPS/NPSUpdatedCalendar";
import { useCalendarScroll } from "@/features/calendar/hooks/useCalendarScroll";

import { CalendarDateAxis } from "../DateAxis/CalendarDateAxis";
import { useCalendarDimensions } from "../../hooks/useCalendarDimensions";

import CalendarBackground from "./CalendarBackground";
import { CalendarNonWorkingHours } from "./CalendarNonWorkingHours";
import { CalendarWorkingHours } from "./CalendarWorkingHours";

import "./styles.scss";

export const CalendarContainer = forwardRef(function CalendarContainer(
  { children, className, daysToDisplay, workingHours },
  refs,
) {
  const { calendarBackgroundRef, stickyHeaderRef } = refs;
  const { calendarRect } = useCalendarDimensions(calendarBackgroundRef, stickyHeaderRef);
  const { hasScrolledForFirstTime } = useCalendarScroll(calendarRect, daysToDisplay, workingHours);

  return (
    <div
      className="CalendarContainer__body"
      style={{
        opacity: hasScrolledForFirstTime ? 100 : 0,
      }}
    >
      <FeatureGate
        defaultFlagValue={true}
        disabledFallback={<></>}
        flagName={FeatureFlagEnum.updatedCalendarNps}
      >
        <NPSUpdatedCalendar />
      </FeatureGate>

      <div
        className={`CalendarContainer__sticky-header-container ${className}`}
        ref={stickyHeaderRef}
      >
        <CalendarDateAxis
          className={daysToDisplay.length === 1 ? "day" : "week"}
          daysToDisplay={daysToDisplay}
        />
      </div>

      <CalendarBackground
        calendarRect={calendarRect}
        daysToDisplay={daysToDisplay}
        ref={calendarBackgroundRef}
      />

      <CalendarNonWorkingHours calendarRect={calendarRect} numberOfDays={daysToDisplay.length} />

      <CalendarWorkingHours
        calendarRect={calendarRect}
        daysToDisplay={daysToDisplay}
        workingHours={workingHours}
      />
      {children}
    </div>
  );
});
